import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { checkIsPro, useWorkspaceSelector } from '@futrli/shared-services';
import { PREDICT_TRIAL_PERIOD_HOURS } from '@futrli/predict/core/config';
import { ProductSetup } from '@futrli-sdk/organisations';

/**
 * Custom hook to determine the product status for the current workspace
 * @param productSetup - Product setup information
 */
export const useProductStatus = (productSetup: ProductSetup) => {
  const { workspaceId: tempWorkspaceId } = useParams();
  const workspaceId = tempWorkspaceId as string;
  const workspace = useWorkspaceSelector(workspaceId);

  const { isPro, isSubscriptionStatePending } = useMemo(() => {
    if (workspace && workspace.subscription_state) {
      return {
        isPro: workspace.subscription_state === 'trial' || workspace.subscription_state === 'active',
        isSubscriptionStatePending: workspace.subscription_state === 'pending'
      };
    } else {
      return {
        isPro: checkIsPro(productSetup, Number(PREDICT_TRIAL_PERIOD_HOURS)),
        isSubscriptionStatePending: false
      };
    }
  }, [workspace, productSetup]);

  return { isPro, isSubscriptionStatePending };
};
